export default {
  // Este componente não tem strings de texto estáticas traduzíveis
  // Usa dados dinâmicos passados de props
}
